const styles = () => ({
    tableCellBorder: {
        border: '1px solid darkgray',
    },
    tableCellOldValue: {
        border: '1px solid darkgray',
        backgroundColor: '#fff9c4',
    },
    tableCellNewValue: {
        border: '1px solid darkgray',
        backgroundColor: '#c8e6c9',
    },
    centerProgress: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
    },
    zebraRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#f9f9f9',
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#ffffff',
        },
    },
    headerCell: {
        backgroundColor: '#bdbdbd',
        fontWeight: 'bold'
    },
    UPDATE: {
        backgroundColor: '#90caf9',
        fontWeight: 'bold',
    },
    INSERT: {
        backgroundColor: '#a5d6a7',
        fontWeight: 'bold'
    },
    DELETE: {
        backgroundColor: '#ef9a9a',
        fontWeight: 'bold'
    },
    SEARCH: {
        backgroundColor: '#fff59d',
        fontWeight: 'bold',
    },
    allCells: {
        verticalAlign: 'middle'
    },
    operationBox: {
        display: 'flex',
        alignItems: 'center',
    },
    operationIcon: {
        display: 'inline-block',
        width: 20,
        height: 20,
        borderRadius: '50%',
        marginRight: 8,
        border: '1px solid black',
    },
    operationLabel: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 12,
        color: '#fff',
        fontWeight: 500,
        fontSize: 12,
        minWidth: 60,
        textAlign: 'center',
        border: '1px solid black'
    },
    iconSearch: {
        backgroundColor: '#f9a825',
    },
    iconUpdate: {
        backgroundColor: '#1565c0',
    },
    iconInsert: {
        backgroundColor: '#2e7d32',
    },
    iconDelete: {
        backgroundColor: '#c62828',
    },
    perfilExterno: {
        backgroundColor: 'darkgray',
        color: 'black',
    },
    perfilInterno: {
        backgroundColor: 'white',
        color: 'black',
    },
    perfilAnonimo: {
        backgroundColor: '#cfd8dc',
        color: 'gray',
    },
    campoColumn: {
        width: '1%',
        whiteSpace: 'nowrap',
        verticalAlign: 'top',
    }
});

export default styles;
